export default "__VITE_ASSET__6a6220f6__"